import {FRAME_CHARGER_SERIAL} from '../../consts/scp/scpFrames';
import iotDeviceFeatureConfigService from '../iotDevice/iotDeviceFeatureConfigService';
import pairingService from '../pairingService';
import connectivityService from './connectivityService';
import framesProcessingService from './framesProcessingService';

const pingDeviceIfNeeded = () => {
    const isIdlePingNeeded = getIsIdlePingNeeded();

    if (!isIdlePingNeeded) return;

    const isDeviceConnected = pairingService.isDeviceConnected();

    if (!isDeviceConnected) {
        return;
    }

    writePingFrame();
};

const writePingFrame = () => {
    let onErrorWasCalled;

    framesProcessingService.processFrames({
        frames: [FRAME_CHARGER_SERIAL],
        retryCount: 0,
        processFirst: true,
        onError: () => {
            // prevent infinite loop from stopDeviceSchedulers->clearQueue->onError
            if (onErrorWasCalled) return;
            onErrorWasCalled = true;

            pairingService.onDeviceDisconnect();
        },
    });
};

const getIsIdlePingNeeded = () => {
    const isBle = connectivityService.isBle();

    if (!isBle) return false;

    const isIdlePingEnabled = iotDeviceFeatureConfigService.isIdlePingEnabled();

    return isIdlePingEnabled;
};

export default {
    pingDeviceIfNeeded,
    getIsIdlePingNeeded,
    writePingFrame,
};
